export const CAPSULE_LANE_HEIGHT = 18;

export const LANE_LABEL_HEIGHT = 14;
